(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 1382:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(6364);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./comps/button.tsx
var comps_button = __webpack_require__(5896);
// EXTERNAL MODULE: ./comps/crisp.tsx + 1 modules
var crisp = __webpack_require__(9889);
// EXTERNAL MODULE: ./comps/footer/index.tsx + 4 modules
var footer = __webpack_require__(8109);
// EXTERNAL MODULE: ./comps/header/index.tsx + 2 modules
var header = __webpack_require__(1083);
// EXTERNAL MODULE: ./comps/input.tsx
var input = __webpack_require__(5792);
// EXTERNAL MODULE: ./comps/message.tsx
var comps_message = __webpack_require__(9034);
// EXTERNAL MODULE: ./comps/meta.tsx
var meta = __webpack_require__(624);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./comps/radio.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  position: relative;\n  margin: 0 0 10px;\n  font-size: 16px;\n  line-height: 24px;\n\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: block;\n  padding: 0 0 0 24px;\n  cursor: pointer;\n\n  :before {\n    content: "";\n    position: absolute;\n    top: 4px;\n    left: 0;\n    width: 16px;\n    height: 16px;\n    background-color: transparent;\n    border: 1px solid var(--color-blue-600);\n    border-radius: 14px;\n    z-index: 1;\n    transition: border-color 0.28s\n      cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  :after {\n    content: "";\n    position: absolute;\n    top: 8px;\n    left: 4px;\n    width: 8px;\n    height: 8px;\n    background-color: var(--color-primary-500);\n    border-radius: 50%;\n    z-index: 2;\n    transform: scale(0, 0);\n    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 4px;\n  left: 0;\n  width: 36px;\n  height: 20px;\n  opacity: 0;\n  z-index: 0;\n\n  cursor: pointer;\n\n  &:checked + ",
        ":before {\n    border-color: var(--color-primary-500);\n  }\n\n  &:checked + ",
        ":after {\n    transform: scale(1, 1);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var RadioContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e24fb19-0"
})(_templateObject());
var RadioLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-5e24fb19-1"
})(_templateObject1());
var RadioInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-5e24fb19-2"
})(_templateObject2(), RadioLabel, RadioLabel);
var Radios = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.labels.map(function(label, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioInput, {
                        onChange: function() {
                            return props.onChange && props.onChange(index);
                        },
                        type: "radio",
                        name: props.name,
                        id: props.name + index,
                        defaultChecked: index === props.checked
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioLabel, {
                        htmlFor: props.name + index,
                        children: label
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var comps_radio = (Radios);

// EXTERNAL MODULE: ./comps/tooltip.tsx
var tooltip = __webpack_require__(4773);
// EXTERNAL MODULE: ./utils/breakpoints.tsx
var breakpoints = __webpack_require__(1156);
// EXTERNAL MODULE: ./utils/notification.tsx
var notification = __webpack_require__(4371);
// EXTERNAL MODULE: ./utils/validators.ts
var validators = __webpack_require__(9480);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(9204);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(259);
// EXTERNAL MODULE: ./node_modules/react-styled-flex/dist/react-styled-flex.esm.js
var react_styled_flex_esm = __webpack_require__(4382);
;// CONCATENATED MODULE: ./pages/contact.tsx




function contact_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n\n  width: calc(var(--w-screen) - 32px);\n  min-height: calc(100vh - 540px);\n\n  @media ",
        " {\n    width: 605px;\n  }\n\n  @media ",
        " {\n    width: 1175px;\n  }\n"
    ]);
    contact_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function contact_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  display: flex;\n  flex-direction: column-reverse;\n\n  align-items: flex-start;\n\n  gap: 16px;\n\n  @media ",
        " {\n    flex-direction: row;\n    gap: 25px;\n  }\n"
    ]);
    contact_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function contact_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: capitalize;\n  text-align: center;\n\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 21px;\n\n  margin: 16px 0;\n\n  @media ",
        " {\n    font-size: 24px;\n    line-height: 29px;\n\n    margin: 12px 0 21px 0;\n  }\n\n  @media ",
        " {\n    font-weight: 800;\n    font-size: 36px;\n    line-height: 52px;\n\n    margin-bottom: 48px;\n  }\n"
    ]);
    contact_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  gap: 16px;\n\n  padding: 24px;\n  border-radius: 12px;\n\n  background-color: var(--color-background-cell);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 21px;\n\n  @media ",
        " {\n    font-size: 22px;\n    line-height: 26px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 25px;\n\n  @media ",
        " {\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 300px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  @media ",
        " {\n    width: 605px;\n  }\n\n  @media ",
        " {\n    width: 375px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 22px;\n\n  align-self: center;\n\n  @media ",
        " {\n    align-self: flex-start;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  @media ",
        " {\n    width: 605px;\n  }\n\n  @media ",
        " {\n    width: 775px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: block;\n\n    width: calc(100% + 48px);\n    height: 1px;\n\n    background-color: var(--color-separator);\n    margin: 0 -24px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n\n  @media ",
        " {\n    height: 170px;\n\n    column-gap: 80px;\n    row-gap: 24px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n\n  list-style: disc inside;\n\n  padding: 12px 0;\n  border-top: 1px solid var(--color-separator);\n\n  @media ",
        " {\n    padding: 0;\n    border-top: unset;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 19px;\n\n  color: var(--color-blue-600);\n\n  text-transform: uppercase;\n\n  span {\n    margin-left: -8px;\n  }\n\n  @media ",
        " {\n    span {\n      margin-left: unset;\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: flex-start;\n  letter-spacing: 0.04em;\n\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n\n  color: var(--color-blue-900);\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  @media ",
        " {\n    flex-direction: row;\n    gap: 24px;\n  }\n\n  @media ",
        " {\n    flex-direction: column;\n    gap: 0;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  input {\n    text-transform: capitalize;\n  }\n\n  flex: 1;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}



















var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-56b6dbb6-0"
})(contact_templateObject(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-56b6dbb6-1"
})(contact_templateObject1(), breakpoints/* devices.desktop */.Hb.desktop);
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-56b6dbb6-2"
})(contact_templateObject2(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var Block = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-56b6dbb6-3"
})(_templateObject3());
var Label = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-56b6dbb6-4"
})(_templateObject4(), breakpoints/* devices.tablet */.Hb.tablet);
var TextContent = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-56b6dbb6-5"
})(_templateObject5(), breakpoints/* devices.tablet */.Hb.tablet);
var ContactTextContent = (0,styled_components_browser_esm/* default */.ZP)(TextContent).withConfig({
    componentId: "sc-56b6dbb6-6"
})(_templateObject6());
var ContactForm = (0,styled_components_browser_esm/* default */.ZP)(Block).withConfig({
    componentId: "sc-56b6dbb6-7"
})(_templateObject7(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var contact_RadioContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-56b6dbb6-8"
})(_templateObject8(), breakpoints/* devices.desktop */.Hb.desktop);
var Help = (0,styled_components_browser_esm/* default */.ZP)(Block).withConfig({
    componentId: "sc-56b6dbb6-9"
})(_templateObject9(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var Line = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-56b6dbb6-10"
})(_templateObject10(), breakpoints/* devices.tablet */.Hb.tablet);
var EmailsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-56b6dbb6-11"
})(_templateObject11(), breakpoints/* devices.tablet */.Hb.tablet);
var SingleEmail = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-56b6dbb6-12"
})(_templateObject12(), breakpoints/* devices.tablet */.Hb.tablet);
var EmailLabel = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-56b6dbb6-13"
})(_templateObject13(), breakpoints/* devices.tablet */.Hb.tablet);
var EmailAddress = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-56b6dbb6-14"
})(_templateObject14());
var InputContainer = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-56b6dbb6-15"
})(_templateObject15());
var TabletRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-56b6dbb6-16"
})(_templateObject16(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var NameInput = (0,styled_components_browser_esm/* default */.ZP)(input/* default */.ZP).withConfig({
    componentId: "sc-56b6dbb6-17"
})(_templateObject17());
var PhoneInput = (0,styled_components_browser_esm/* default */.ZP)(input/* default */.ZP).withConfig({
    componentId: "sc-56b6dbb6-18"
})(_templateObject18());
var Contact = function() {
    var t = (0,esm/* useTranslation */.$G)("page-contact").t;
    var ref = (0,react.useState)(""), name = ref[0], setName = ref[1];
    var ref1 = (0,react.useState)(""), phone = ref1[0], setPhone = ref1[1];
    var ref2 = (0,react.useState)(""), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react.useState)(""), message = ref3[0], setMessage = ref3[1];
    var ref4 = (0,react.useState)(1), intention = ref4[0], setIntention = ref4[1];
    var ref5 = (0,react.useState)(false), loading = ref5[0], setLoading = ref5[1];
    var ref6 = (0,input/* useValidator */.ny)(name, [
        validators/* notEmpty */.Dw
    ]), nameValidate = ref6.validate, nameErrors = ref6.errors;
    var ref7 = (0,input/* useValidator */.ny)(email, [
        validators/* notEmpty */.Dw,
        validators/* isEmail */.Jh
    ]), emailValidate = ref7.validate, emailErrors = ref7.errors;
    var ref8 = (0,input/* useValidator */.ny)(message, [
        validators/* notEmpty */.Dw
    ]), messageValidate = ref8.validate, messageErrors = ref8.errors;
    var formRef = (0,react.useRef)(null);
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    var anyError = !(name && email && message && !nameErrors && !emailErrors && !messageErrors);
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var submitHandler = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var captcha, data, e1, ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (loading) return [
                            2,
                            notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* WarningMessage */.jB, {
                                children: t("common:txt_loading_wait")
                            }))
                        ];
                        if (anyError) return [
                            2,
                            notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* WarningMessage */.jB, {
                                children: t("common:txt_please_fill_input")
                            }))
                        ];
                        if (executeRecaptcha === undefined) return [
                            2,
                            notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* WarningMessage */.jB, {
                                children: t("common:txt_recaptcha_not_loaded")
                            }))
                        ];
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            executeRecaptcha()
                        ];
                    case 2:
                        captcha = _state.sent();
                        data = {
                            name: name,
                            phone: phone || null,
                            email: email,
                            message: message,
                            captcha: captcha,
                            intention: intention ? "individual" : "business"
                        };
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/contact", data)
                        ];
                    case 3:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* SuccessMessage */.kk, {
                            children: t("common:txt_contact_success")
                        }));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e1 = _state.sent();
                        if ((0,_instanceof/* default */.Z)(e1, node_modules_axios/* AxiosError */.d7) && ((ref = e1.response) === null || ref === void 0 ? void 0 : ref.data.code) === "logic") {
                            notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* ErrorMessage */.Bc, {
                                children: t("common:txt_captcha_failed")
                            }));
                        } else {
                            notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* ErrorMessage */.Bc, {
                                children: t("common:txt_contact_error")
                            }));
                        }
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setLoading(false);
                        setName("");
                        setPhone("");
                        setEmail("");
                        setMessage("");
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        anyError,
        email,
        executeRecaptcha,
        intention,
        loading,
        message,
        name,
        notify,
        phone,
        t, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, {
                title: t("page-contact:txt_page_title"),
                description: t("page-contact:txt_page_description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.ZP, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: t("lbl_contact_us", {
                            ns: "common"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactForm, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                        children: t("common:txt_get_in_touch")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactTextContent, {
                                        children: t("txt_have_an_inquiry")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
                                        onSubmit: submitHandler,
                                        ref: formRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabletRow, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NameInput, {
                                                        validate: nameValidate,
                                                        errors: nameErrors,
                                                        value: name,
                                                        setValue: setName,
                                                        label: t("common:txt_full_name"),
                                                        type: "text",
                                                        name: "name"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput, {
                                                        value: phone,
                                                        setValue: setPhone,
                                                        label: t("common:txt_phone_number_optional"),
                                                        type: "tel",
                                                        name: "phone"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.ZP, {
                                                validate: emailValidate,
                                                errors: emailErrors,
                                                value: email,
                                                setValue: setEmail,
                                                label: t("common:txt_email_addr"),
                                                type: "email",
                                                name: "email"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Textarea */.gx, {
                                                validate: messageValidate,
                                                errors: messageErrors,
                                                label: t("txt_your_message"),
                                                value: message,
                                                setValue: setMessage,
                                                rows: 3
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* Box */.xu, {
                                                height: 12
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.ZP, {
                                                title: t("common:txt_please_fill"),
                                                disabled: Boolean(anyError),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                                    loading: loading,
                                                    disabled: Boolean(anyError) || loading,
                                                    primary: true,
                                                    text: "page-contact:lbl_submit"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_RadioContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_radio, {
                                            labels: [
                                                t("common:lbl_business"),
                                                t("common:lbl_individual"), 
                                            ],
                                            name: "type",
                                            checked: intention,
                                            onChange: setIntention
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Help, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                        children: t("txt_we_are_here")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent, {
                                        children: t("txt_any_questions")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Line, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailsContainer, {
                                        children: [
                                            {
                                                label: "for_joining",
                                                address: "hr@zoomerang.app"
                                            },
                                            {
                                                label: "for_technical_issues",
                                                address: "support@zoomerang.app"
                                            },
                                            {
                                                label: "for_feedback",
                                                address: "feedback@zoomerang.app"
                                            },
                                            {
                                                label: "for_marketing",
                                                address: "promotion@zoomerang.app"
                                            },
                                            {
                                                label: "for_general_questions",
                                                address: "info@zoomerang.app"
                                            }, 
                                        ].map(function(param, index) {
                                            var label = param.label, address = param.address;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SingleEmail, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailLabel, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: t("txt_" + label)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAddress, {
                                                        href: "mailto:" + address,
                                                        children: address
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(crisp/* default */.Z, {
                page: "contact"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* default */.Z, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var contact = (Contact);


/***/ }),

/***/ 9480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dw": function() { return /* binding */ notEmpty; },
/* harmony export */   "Jh": function() { return /* binding */ isEmail; },
/* harmony export */   "Mn": function() { return /* binding */ isPhone; }
/* harmony export */ });
/* unused harmony export isPhoneOrEmpty */
/* harmony import */ var _swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9637);

var notEmpty = function(value, t) {
    if (value.length === 0) return t("txt_error_not_empty");
};
var isEmail = function(value, t) {
    var atIndex = value.indexOf("@");
    var dotIndex = value.lastIndexOf(".");
    var atSymbols = value.split("@");
    if (atIndex === 0) return t("txt_error_cannot_start_with_at");
    if (atIndex === -1) return t("txt_error_should_contain_at");
    if (dotIndex === -1 || dotIndex < atIndex || dotIndex === value.length - 1) return t("txt_error_email_wrong_domain");
    if (atSymbols.length > 2) return t("txt_error_email_one_at");
};
var isPhone = function(value, t) {
    var plusIndex = value.lastIndexOf("+");
    if (plusIndex !== 0 && plusIndex !== -1) return t("txt_error_plus_middle");
    var ref = (0,_swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value.split("")), _ = ref[0], numbers = ref.slice(1);
    if (numbers.join("").match(/[^0-9\s]/) !== null) return t("txt_error_only_numbers_and_plus");
    if (value.length <= 6) return t("txt_error_short_phone");
    if (value[0] !== "0" && value[0] !== "+") return t("txt_error_phone_format");
};
var isPhoneOrEmpty = function(value, t) {
    if (!value) {
        return undefined;
    }
    return isPhone(value, t);
};


/***/ }),

/***/ 9637:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9474);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3375);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3128);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1566);





function _toArray(arr) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(1382); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);